
import store from '@/store/index'
import router from '../router'

export function setInterceptors(instance) {
  instance.interceptors.request.use(
    function(config) {
      // Do something before request is sent
      config.headers.Authorization = `Bearer ${store.state.acessToken}`
      return config
    },
    function(error) {
      // Do something with request error
      return Promise.reject(error)
    }
  )

  // Add a response interceptor
  instance.interceptors.response.use(
    function(response) {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      // console.log(response)
      if (response.status === 423) {
        router.push('/maintenance')
        store.commit('toast', {
          toast: false,
          toast_msg: ''
        })
      }
      return response
    },
    function(error) {
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error

      // router.push('/maintenance')
      // store.commit('toast', {
      //   toast: false,
      //   toast_msg: ''
      // })
      // console.log(error, error.response)
      if (error.response && error.response.status === 423) {
        router.push('/maintenance')
        store.commit('toast', {
          toast: false,
          toast_msg: ''
        })
      }

      if (
        error.response &&
        (error.response.status === 401 || error.response.status === 419)
      ) {
        store.dispatch('LOGOUT')
        router.push('/signin')
        store.dispatch('toast', {
          toast: true,
          toast_msg: `세션이 만료되었습니다. 다시 로그인해주세요.`,
          timeout: 2000
        })
      }
      return Promise.reject(error)
    }
  )
  return instance
}
